import React from "react";
import MarkdownRenderer from "../../MarkdownRenderer";

type UtilityAgentProps = {
  parsedContent: any;
};

export default function UtilityAgent({ parsedContent }: UtilityAgentProps): JSX.Element {
  return (
    <div>
      <MarkdownRenderer content={parsedContent?.finalAnswer?.toString()} />
    </div>
  );
}
